import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { IssueWithJourney } from '@tom-ui/operations'
import { IssueStatusChip } from '@tom-ui/planning/pages/Issues/Components/atoms/IssueStatusChip'
import { IContainerJourneyItem } from '@tom-ui/planning/pages/Issues/Stores/ContainerJourneyItem'
import { ContainerVisitsCard } from '@tom-ui/planning/pages/Order/components/ContainerVisitsCard/ContainerVisitsCard'
import { ContainerJourney } from '@tom-ui/planning/pages/ServiceOrders/Stores/ContainerJourney'
import { observer } from 'mobx-react-lite'
import { AggregateIssuesViewStore } from '../Stores/AggregateIssuesViewStore'

interface Props {
  store: AggregateIssuesViewStore
  issue: IssueWithJourney
  hasResolve?: boolean
  containerJourney?: IContainerJourneyItem
}
export const OperationsIssueCard = observer(
  ({ issue, store, hasResolve, containerJourney }: Props) => {
    const { t } = useTranslate()

    const containerVisit = containerJourney ? ContainerJourney.create(containerJourney) : undefined

    return (
      <Paper variant='outlined'>
        <Box sx={{ padding: '1rem', display: 'flex' }}>
          <Stack
            direction='row'
            spacing={1}
            alignItems='center'
            justifyContent='space-between'
            width='100%'
          >
            <Typography variant='h4'>
              {t(
                issue.issueType === 'WorkInstructionUnfinished'
                  ? t('missingPosition', 'Missing position')
                  : t('unknown', 'Unknown'),
              )}
            </Typography>
            <Stack direction='row' spacing={1} alignItems='center'>
              <IssueStatusChip status={issue.issueStatus} />
              {hasResolve && (
                <Button
                  size='medium'
                  variant='contained'
                  onClick={() => store.toggleMissingPositionIssue(issue)}
                >
                  {t('resolve', 'Resolve')}
                </Button>
              )}
            </Stack>
          </Stack>
        </Box>

        {containerVisit && (
          <ContainerVisitsCard
            containerVisit={containerVisit}
            announcedVisits={[]}
            isInsideIssueCard
          />
        )}
      </Paper>
    )
  },
)
